module.exports = __webpack_public_path__ + "img/stars.3a4f15cc.png";